// Pure helpers for the Blind Box ban form (kept out of JSX so they can be unit tested).

export const BAN_REASON_MAX = 255;

export type BanForm = { userId: string; walletAddress: string; reason: string };

/**
 * Validates the "Ban user" form: exactly one of userId / walletAddress, reason required (<= 255).
 * When `fixedTarget` is true the identifier comes from the caller (e.g. a leaderboard row) and only
 * the reason is checked. Returns an i18n key or null.
 */
export function validateBanForm(form: BanForm, fixedTarget = false): string | null {
  if (!fixedTarget) {
    const hasUser = !!form.userId.trim();
    const hasWallet = !!form.walletAddress.trim();
    if (!hasUser && !hasWallet) return 'module.blindBox.banErrMissingTarget';
    if (hasUser && hasWallet) return 'module.blindBox.banErrBothTargets';
  }
  const reason = form.reason.trim();
  if (!reason) return 'module.blindBox.banErrReasonRequired';
  if (reason.length > BAN_REASON_MAX) return 'module.blindBox.banErrReasonTooLong';
  return null;
}

/** Builds the POST /blind-box/ban-user body for a ban (sends only the identifier that was entered). */
export function buildBanBody(form: BanForm): {
  userId?: string;
  walletAddress?: string;
  banned: true;
  reason: string;
} {
  const body: { userId?: string; walletAddress?: string; banned: true; reason: string } = {
    banned: true,
    reason: form.reason.trim(),
  };
  if (form.userId.trim()) body.userId = form.userId.trim();
  else body.walletAddress = form.walletAddress.trim();
  return body;
}
